/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useContext,
} from 'react';
import { useStep } from 'react-hooks-helper';
import * as Api from 'core/api/customer2Fa/customer2FaApi';
import Loading from 'components/Loading';
import { getUrlParams } from '../../core/Utils/getUrlParams';
import { MondrianModal } from 'components/Mondrian/Modal';
import TokenValidate from 'components/TokenValidate';
import SimplePage from 'components/SimplePage';
import Customer2FaStepper from 'components/Customer2FaStepper';
import { Icon, Link, Text } from 'mondrian-react';
import { Strong } from 'components/Strong';
import { store } from 'store.js';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import tagAdapter,{tagClaroId} from "../../core/Utils/Analytics/tagAdapter";
import {TagTypeGa4,factorType} from "../../core/Utils/Analytics/tagType";
import {isTwoFactor,isNullOrBlank} from "../../core/Utils/Utils";
const steps = [{ id: "validar-token" }, { id: "sucesso" }];
const BackButton = styled.div`
  a {
    text-decoration: none;
    span {
      vertical-align: middle;
      height: 15px;
      margin-right: 5px;
    }
  }
`;

const Customer2Fa = ({ images }) => {
  const {
    state: {
      analytics: { currentFlow = 'customer2fa' },
    },
    dispatch,
  } = useContext(store);
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;
  const [isLoading, setIsLoading] = useState(true);
  const [description, setDescription] = useState('');
  const [userData, setUserData] = useState({});
  const [redirectCallback, setRedirectCallback] = useState('');
  const { next } = navigation;
  const [modalContent, setModalContent] = useState(null);
  const [TwoFactor, setTwoFactor] = useState(null);
  const uuid = uuidv4();

  const props = {
    navigation,
    isLoading,
    redirectCallback,
    setModalContent,
  };

  const style = {
    listStyle: 'inside',
    marginLeft: '0.7rem',
  };

  useEffect(function () {
    const script = document.createElement('script');
    script.id = 'clearsale';
    var s = document.getElementsByTagName('script')[0];
    script.text = `(function (a, b, c, d, e, f, g) { a['CsdpObject'] = e; a[e] = a[e] || function () { (a[e].q = a[e].q || []).push(arguments) }, a[e].l = 1 * new Date(); f = b.createElement(c), g = b.getElementsByTagName(c)[0]; f.async = 1; f.src = d; g.parentNode.insertBefore(f, g) })(window, document, 'script', '//device.clearsale.com.br/p/fp.js', 'csdp'); csdp('app', '%REACT_APP_FINGERPRINT%'); csdp('sessionid','${uuid}')`;
    s.parentNode.insertBefore(script, s);
    document.body.appendChild(script);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(function () {
    dispatch({
      type: "SET_GA",
      payload: { currentFlow: "customer2fa", currentStep: id },

    });
    let token = getUrlParams("token");
    let client_id = getUrlParams("client_id");
    handleSendToken({ token, client_id, session_id: uuid });
   
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function () {
    dispatch({
      type: "SET_GA",
      payload: { currentFlow: "customer2fa", currentStep: id },

    });
    // tagAdapter({step:id},TagTypeGa4.PAGEVIEW)
    // Analytics().setVirtualPageView(`/meuperfil/customer2fa/${id}`);
  }, [dispatch, id]);


  

  function dispatchClaroId(claroId) {
    if(!isNullOrBlank(claroId) ){
      tagClaroId(claroId)
      }
  }

  function onRequestClose(data = {}) {
    setModalContent(null);
  }

  async function handleSendToken(userData) {

    setIsLoading(true);
    let result = await Api.SendToken(userData);
    let { error = null, data, code } = result;
    if (error) {
      let { title } = error.warning;

      if(code === 500 || error?.warning?.id === "INESPERADO") {
        title=`erro_inesperado_${error?.errorCode}`
        error.warning = {
          ...error.warning,
          disableCloseButton: true,
          buttons: [
            {
              label: 'Tentar novamente',
              onClick: () => handleSendToken(userData),
            },
          ],
        };
      }


      
      setModalContent(error);
      
      tagAdapter({tipo_erro:title,tipo_callback:factorType.PRE_FACTOR},TagTypeGa4.ERROR)
      setIsLoading(false);

      return null;
    }
    dispatchClaroId(data?.claroId)
    setRedirectCallback(data.urlCallback);
    setIsLoading(false);
    setUserData({userData: data.userData});
    setTwoFactor(isTwoFactor(data?.netLoginEmail,data?.loginPhoneNumber))
    if(data.loginPhoneNumber !== '' && data.loginPhoneNumber !== undefined && data.netLoginEmail !== '') {
      setDescription(['O mesmo código será enviado para:', <br />, 
      <><ul><li style={style}><strong>{data.netLoginEmail}</strong></li><li style={style}><strong>{data.loginPhoneNumber}</strong></li></ul><br /></>, 
      'Apenas um código é necessário.', <br />, 'Válido por 10 minutos.']);
    } else if(data.netLoginEmail !== '' || (data.loginPhoneNumber !== '' && data.loginPhoneNumber !== undefined)){
      setDescription(['Confira o código enviado para:', <br />, 
      <><ul><li style={style}><strong>{data.netLoginEmail !== '' ? data.netLoginEmail : data.loginPhoneNumber}</strong></li></ul></>, 
      <br />, 'Válido por 10 minutos.']);
    } else {
      setDescription([
        'Confira o código enviado para:',
        <br />,
        <>
          <ul>
            <li style={style}>
              <strong>{data.netLoginEmail}</strong>
            </li>
          </ul>
        </>,
        <br />,
        'Válido por 10 minutos.',
      ]);
    }
  }

  async function handleResendToken() {
    setIsLoading(true);
    let result = await Api.ReSendToken(userData);
    let { error = null, data = null } = result;

    if (error != null) {
      let { title } = error.warning;
      if( error?.warning?.id === "INESPERADO") {
        title=`erro_inesperado_${error?.errorCode}`
      }
      setModalContent(error);

      tagAdapter({tipo_erro:title,tipo_callback:TwoFactor},TagTypeGa4.ERROR)
      
      if(data?.userData) {
        setUserData({userData: data.userData});
      }
    } else {
      setUserData({ userData: data.userData });
    }

    setIsLoading(false);
  }
  function handleTagAdapter(options, currentFlow)  {

    if(currentFlow ==="customer2fa"){
    tagAdapter(options,TagTypeGa4.BUTTON)
    }
  }


  async function handleValidateToken(token) {
    setIsLoading(true);
    const submitFormData = {
      token,
      ...userData,
    };
    let result = await Api.ValidateToken(submitFormData);
    setIsLoading(false);

    let { error = null, data = null } = result;

    if (error != null) {
      let { title } = error.warning;
      if( error?.warning?.id === "INESPERADO") {
        title=`erro_inesperado_${error?.errorCode}`
      }
      setModalContent(error);

      tagAdapter({tipo_erro:title,tipo_callback:TwoFactor},TagTypeGa4.ERROR)
      if(data?.userData) {
        setUserData({userData: data.userData});
      }
    } else {
      tagAdapter({tipo_callback:TwoFactor},TagTypeGa4.SUCCESS)

      next();

      setInterval(() => {
        window.location.href = result.data.urlCallback;
      }, 7000);
    }
  }

  if (isLoading) return <Loading isLoading={isLoading} />;

  switch (id) {
    case 'validar-token':
      return (
        <>
       
          <BackButton className="cred-Customer2FaBack">
            <Link
              tag="a"
              href={redirectCallback}
              onClick={() => handleTagAdapter({ "nome_item": "voltar", "nome_secao": id }, currentFlow)}
            >
              <Icon name="seta-esquerda" md aria-hidden="true" />
              Voltar
            </Link>
          </BackButton>
          {modalContent && (
            <MondrianModal onClose={onRequestClose} content={modalContent}/>
          )}
          <Customer2FaStepper activeStep={0} />

          <TokenValidate
            {...props}
            title='Precisamos confirmar os seus dados'
            description={description}
            onResendToken={handleResendToken}
            onSubmit={handleValidateToken}
          />
        </>
      );
    case 'sucesso':
      return (
        <>
          <Customer2FaStepper activeStep={1} />

          <SimplePage
            title={[
              'Você autenticou seus dados, siga para as próximas etapas!',
            ]}
          >
            <Text>Seus dados foram confirmados para a sua segurança.</Text>
            <Text>
              <Strong>Aguarde para redirecionamento...</Strong>
            </Text>
          </SimplePage>
        </>
      );
    default:
      return null;
  }
};

export default Customer2Fa;
